import React from "react";

// Palier de fidélité d'un membre au sein d'UN lieu (visites/événements réels, cf.
// OLTODO-backend/src/utils/venueTiers.ts pour le calcul exact, identique côté serveur) — jamais
// un statut propagé partout dans l'app comme l'anneau de Vibe : cette couronne n'apparaît que
// dans la liste des abonnés/membres d'un lieu, ou sur son propre avatar dans "Ma carte de
// fidélité", toujours sur la fiche de CE lieu précis.
export type VenueTier = "bronze" | "silver" | "gold";

export const TIER_COLORS: Record<VenueTier, string> = {
  bronze: "#CD7F32",
  silver: "#AEB2B8",
  gold: "#D4AF37",
};

export const TIER_LABELS: Record<VenueTier, string> = {
  bronze: "Bronze",
  silver: "Silver",
  gold: "Gold",
};

// Couronne SVG toujours légèrement inclinée, posée sur le cercle de la photo de profil — un
// disque blanc derrière assure sa lisibilité quelle que soit la photo en dessous. Port 1:1 du
// composant mobile (components/CrownBadge.tsx).
export function CrownBadge({ tier, avatarSize }: { tier: VenueTier; avatarSize: number }) {
  const size = Math.max(16, Math.round(avatarSize * 0.46));
  return (
    <div
      style={{
        position: "absolute", top: -size * 0.32, right: -size * 0.14,
        width: size, height: size, borderRadius: "50%", backgroundColor: "white",
        display: "flex", alignItems: "center", justifyContent: "center",
        transform: "rotate(-18deg)", boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
      }}
    >
      <svg width={size * 0.66} height={size * 0.66} viewBox="0 0 24 24">
        <path d="M2 18h20l-2-9-5 4-3-7-3 7-5-4-2 9z" fill={TIER_COLORS[tier]} stroke="white" strokeWidth={0.8} strokeLinejoin="round" />
      </svg>
    </div>
  );
}
